<template>
  <div class="dataQuery">
    <box ref="box"></box>
    <el-card shadow="never" :style="style">
      <el-form label-position="right" :model="searchForm" class="form" :inline="true">
        <el-form-item :label="$t('panelNumber')">
          <el-input-number size="mini" v-model="searchForm.controllerNo" @change="handleControllerNo" :min="0"
                           :max="254"
                           label="描述文字"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('loopNo')">
          <el-input-number size="mini" v-model="searchForm.loopNo" @change="handleChangeLoopNo" :min="0" :max="254"
                           label="描述文字"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('componentNumber')">
          <el-input-number size="mini" v-model="searchForm.siteInitiation" @change="handleChange" :min="0" :max="254"
                           label="描述文字"></el-input-number>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button style="width: 90px" type="primary" :loading="searching" @click="handleQuery">
            {{ startAndStop !=='dataQuery' ? $t('queryButton') : $t('stop') }}
          </el-button>
        </el-form-item>
      </el-form>
      <el-form v-if='isShow'>
        <div v-html='dataString' class="data-box"></div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Box from "@/components/Box";
import {getDeviceData, stop} from "@/api/query";
import Status from "components/Status";

export default {
  name: "dataQuery",
  mixins: [Status],
  components: {
    Box
  },
  data() {
    return {
      searchForm: {
        controllerNo: 1,
        loopNo: 1,
        siteInitiation: 1
      },
      bottomHeight: null,
      style: null,
      isShow: false,
      id: "",
      dataUint: [],
      columnSize: 0,
      dataString: '',
      searching: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$store.state.responseErrFlag) {
        vm.searching = false;
        vm.id = "";
        vm.dataString = ''
        vm.dataUint = []
      }
    })
  },
  computed: {
    startAndStop: {
      get() {
        return this.$store.state.startAndStop
      },
      set(val) {
        this.$store.commit('changeStartAndStop', val);
      }
    },
    responseErrFlag(){
      return this.$store.state.responseErrFlag
    }
  },
  mounted() {
    this.calcHeight();
  },
  created(){
    this.searchForm.controllerNo = this.$store.state.controlInfo.controllerNo
  },
  methods: {
    init_data(){
      this.searching = false;
      this.id = "";
      this.dataString = ''
      this.dataUint = []
    },
    calcHeight() {
      setTimeout(() => {
        this.bottomHeight = this.$refs.box.$el.clientHeight + "px";
        this.style = `height: calc(100vh - 100px - ${this.bottomHeight})`;
      }, 20);
    },
    handleChange(value) {
      this.searchForm.siteInitiation = value;
    },
    handleControllerNo(value) {
      console.log(value)
      this.searchForm.controllerNo = value;
    },
    handleChangeLoopNo(value) {
      this.searchForm.loopNo = value;
    },
    handleQuery() {
      const {sysSetting} = this.$store.state;
      const searchParams = {
        controllerPsn: sysSetting.controllerPsn, //控制器PSN
        controllerNo: this.searchForm.controllerNo, //控制器号
        loopNo: this.searchForm.loopNo, //回路号
        codeNo: this.searchForm.siteInitiation, //部位号
        dataType: 1 //默认值1:11SF，2:数据2，3：数据3
      };
      const params = {
        controllerPsn: sysSetting.controllerPsn, //控制器PSN
        id: this.id
      };
      if (this.startAndStop !== 'dataQuery') {
        if (this.startAndStop !== '') {
          this.$message.warning("命令阻塞中!")
          return
        }
        this.show()
        this.searching = true
        getDeviceData(searchParams).then(res => {
          if (res.data) {
            this.id = res.data.id;
            //const currentComponentData = this.$store.state.currentComponentData
            //    if (currentComponentData.request.id === this.id) {
            //     let list = this.dataUint.concat(currentComponentData.dataUint.data);
            //     this.dataUint = list
            //     this.columnSize = currentComponentData.dataUint.columnSize;
            //     var str = '';
            //     for (var i = 0; i < this.dataUint.length; i++) {
            //       if (i > 0 && i % this.columnSize === 0) {
            //         str += `<br/>`;
            //       }
            //       str += `<span class='s-span' style='width:${68 / this.columnSize}%'>${this.dataUint[i]}</span>`;
            //     }
            //     this.dataString = str;
            //     this.isShow = true;
            //     this.startAndStop = false
            // }
            this.$store.commit('changeStartAndStop', "dataQuery");
            sessionStorage.startAndStop = "dataQuery"
            this.success(res.message ? res.message : '操作成功')
          }
        }).catch(() => {
          // this.$store.commit('changeStartAndStop', "");
          // sessionStorage.startAndStop = ""
          this.failed()
          this.searching = false
        })
      } else {
        this.show()
        stop(params).then(res => {
          if (res.data) {
            console.log("停止响应");
            this.id = "";
            this.$store.commit('changeStartAndStop', "");
            sessionStorage.startAndStop = ""
            this.dataString = ''
            this.dataUint = []
            this.searching = false
            this.success(res.message ? res.message : '操作成功')
          } else {
            //  this.$store.commit('changeStartAndStop', "dataQuery");
            //  sessionStorage.startAndStop = "dataQuery"
            this.failed()
            this.searching = false
          }
        }).catch(() => {
          this.failed()
          this.searching = false
        })
      }
    },
    sliceStr(str, len) {
      let result = "";
      let sIndex = 0;
      let eIndex = len / 1;
      while (str.length > sIndex) {
        result += str.slice(sIndex, eIndex) + "<br/>";
        sIndex += len;
        eIndex += len;
      }
      return result;
    }
  },
  watch: {
    "$store.state.currentComponentData"(newVal) {
      if (newVal.request.id === this.id) {
        this.searching = false;
        this.failed()
        let list = this.dataUint.concat(newVal.dataUint.data);
        this.dataUint = list
        this.columnSize = newVal.dataUint.columnSize;
        var str = '';
        for (var i = 0; i < this.dataUint.length; i++) {
          if (i > 0 && i % this.columnSize === 0) {
            str += `<br/>`;
          }
          str += `<span class='s-span' style='width:${68 / this.columnSize}%'>${this.dataUint[i]}</span>`;
        }
        this.dataString = str;
        this.isShow = true;
      }
    },
    responseErrFlag(newVal){
      if (newVal) {
        this.failed();
        // let status = this.$store.state.startAndStop
        // this.$store.commit('changeStartAndStop', status);
        // sessionStorage.startAndStop = status
        this.searching = false;
        this.init_data()
      }
    }
  }
};
</script>

<style scoped>
.popContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}

.data-box {
  width: 68%;
  height: calc((100vh - 138px) - 270px - 70px);
  overflow: auto;
  /* display: flex;
  justify-content: flex-start; */
}

::v-deep .s-span {
  /* display: block; */
  line-height: 36px;
  font-size: 24px;
  font-weight: 600;
  display: inline-block;
  text-align: left;
}
</style>
